import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de.json';
import en from './en.json';

const resources = {
  de: { translation: de },
  en: { translation: en }
};

// Determine initial language from URL path or browser
const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    // Only English if explicitly /en path
    if (path.startsWith('/en')) {
      return 'en';
    }
    
    // Check browser language
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && browserLang.toLowerCase().startsWith('en')) {
      return 'en';
    }
  }
  // Default to German for everything else
  return 'de';
};

const initialLang = getInitialLanguage();
console.log('i18n initializing with language:', initialLang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    detection: {
      order: ['querystring', 'path', 'navigator', 'localStorage'],
      lookupQuerystring: 'lang',
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
